<template>
  <div class="ml-1 mr-3 ad-unit-wrapper">
    <h3 class="mt-2 mb-1">
      Active Ad Units
    </h3>
    <p>
      Select the ad formats you want to run in this campaign
    </p>
    <b-row>
      <b-col
        v-for="adUnit in adUnits"
        :key="adUnit.value"
        :sm="isModalView ? 4 : 12"
      >
        <div
          class="card pl-4 mb-3 d-flex align-items-center flex-row"
          :class="[isModalView ? 'modal-unit-item' : 'unit-item']"
        >
          <div class="m-3">
            <input
              id="adUnits"
              type="checkbox"
              v-model="units"
              name="units"
              :value="adUnit.value"
              :disabled="isCheckBoxDisabled(adUnit.value)"
              @change="updateAdsSelected"
            >
          </div>
          <div :class="[isModalView ? 'ad-column' : 'ad-row']">
            <div class="m-3">
              <i :class="`fa-kit-duotone fa-${adUnit.size}-icon fa-xl`" />
            </div>
            <div class="m-3">
              <h6
                class="mb-0"
                :class="{ 'align-items-center': isModalView }"
              >
                {{ adUnit.size }}
              </h6>
              <p
                class="mb-0 text-muted small"
                :class="{ 'align-items-center': isModalView }"
              >
                {{ adUnit.displayName }}
              </p>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>

import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';
import * as contentTypes from '@/modules/content/store/types';

function initialData() {
  return {
    adUnits: [
      {
        value: 'MEDIUM_RECTANGLE',
        displayName: 'Medium Rectangle',
        size: '300x250',
      },
      {
        value: 'HALF_PAGE',
        displayName: 'Half Page',
        size: '300x600',
      },
      {
        value: 'BILLBOARD',
        displayName: 'Billboard',
        size: '970x250',
      },
    ],
    units: [],
  };
}

export default {
  name: 'AdUnits',
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return initialData();
  },
  computed: {
    ...mapState('content', [
      'adUnitsSelected',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_CAMPAIGN_READONLY,
    ]),
    ...mapGetters('content', [
      contentTypes.GET_CREATIVES_DEFINED,
    ]),
  },
  methods: {
    ...mapActions('content', [
      contentTypes.PUT_CREATIVES_WITH_TYPE,
    ]),
    ...mapMutations('content', [
      contentTypes.SET_ADD_UNITS_SELECTED,
    ]),
    async updateAdsSelected() {
      this.SET_ADD_UNITS_SELECTED(this.units);
      if (this.GET_CREATIVES_DEFINED && this.units.length > 0) {
        await this.PUT_CREATIVES_WITH_TYPE();
      }
    },
    isCheckBoxDisabled(value) {
      if (this.GET_IS_CAMPAIGN_READONLY) return true;
      return this.units.length < 2 && this.units.includes(value);
    },
  },
  created() {
    if (this.adUnitsSelected.length > 0) this.units = this.adUnitsSelected;
    else {
      this.units = this.adUnits.map((adUnit) => adUnit.value);
      this.SET_ADD_UNITS_SELECTED(this.units);
    }
  },
};
</script>
<style scoped lang="scss">
.ad-column {
  display: flex;
  width: 70%;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.ad-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
input[type=checkbox] {
  transform: scale(1.25);
}
.fa-300x250-icon {
  font-size: 2em !important;
}
.fa-300x600-icon {
  font-size: 3.5em !important;
}
.unit-item {
  height: 100px;
}
.modal-unit-item {
  height: 160px;
}
.ad-unit-wrapper {
  width: 100%;
}
</style>
